import React from "react";

type Props = React.SelectHTMLAttributes<HTMLSelectElement> & {
	label?: string;
	help?: string;
	error?: string;
};

export function Select({
	label,
	help,
	error,
	className = "",
	id,
	children,
	...props
}: Props) {
	const generatedId = React.useId();
	const inputId = id ?? generatedId;
	return (
		<div className="space-y-1.5">
			{label ? (
				<label className="label" htmlFor={inputId}>
					{label}
				</label>
			) : null}
			<select
				id={inputId}
				className={`input ${
					error ? "border-[var(--color-danger)]" : ""
				} ${className}`}
				{...props}
			>
				{children}
			</select>
			{help ? <p className="help">{help}</p> : null}
			{error ? (
				<p
					className="help"
					role="alert"
					style={{ color: "var(--danger)" }}
				>
					{error}
				</p>
			) : null}
		</div>
	);
}
